import _ from 'lodash';
import { Component, DestroyRef, inject, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { selectDialogState } from 'app/dialog/features/dialog.selectors';
import { selectOrgUser } from 'app/dashboard/features/dashboard.selectors';
import { filter } from 'rxjs/operators';
import {  UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { loadRecord, resetSurvey } from 'app/dashboard/features/survey.actions';
import { SurveyService } from 'app/dashboard/services/survey.service';
import { MdbModalRef } from 'mdb-angular-ui-kit/modal';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-survey-modal',
  templateUrl: './survey-modal.component.html',
  styleUrls: ['./survey-modal.component.scss']
})
export class SurveyModalComponent implements OnInit, OnDestroy {
  destroyRef = inject(DestroyRef)
  public dialog$: Observable<any> = this.store.pipe(select(selectDialogState));
  public formGroup: UntypedFormGroup = new UntypedFormGroup({
    surveyFeedback: new UntypedFormControl(''),
    surveySkip: new UntypedFormControl(null),
    email:new UntypedFormControl(''),
  })
  public surveyRating  = null
  public isShowMainTitle = true
  public isRatingSelected = true
  public surveyFeedback = '';
  public responseType;
  public postponedFor = null;
  public agreeToContact; 
  public user;
  public textAreaLadel = 'Optionally tell us what you loved...'
  public surveySubtitle =''
  public title = ''
  public activeScreen = 'first'
  public subTitle = ''
  public userEmail;
  public takeUntilSubject: Subject<any> = new Subject();
  public orgUser$ = this.store.pipe(
    select(selectOrgUser),
    filter(user=>!_.isNull(user)),
  )

  constructor(
    private store: Store,
    private surveyService: SurveyService,
  ) { }

  ngOnInit(): void {
    this.title = 'How likely are you to recommend PayBee to a friend?'
    const surveyFeedback = this.formGroup.get('surveyFeedback');
    const surveySkip = this.formGroup.get('surveySkip');
    const email = this.formGroup.get('email');
    let admin = window['localOrgData'].orgUserAccountInfo
    if(admin && admin.email){
      email.setValue(admin.email)
    }else{
      this.orgUser$.pipe(
        takeUntilDestroyed(this.destroyRef)
      ).subscribe((user:any)=>{email.setValue(user.email)})
    }

    surveyFeedback.valueChanges.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(value=>{
      this.surveyFeedback = value
    });
    surveySkip.valueChanges.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(value=>{
      this.postponedFor = value;
      this.onPostponed();
      if(this.surveyService.modalRef instanceof MdbModalRef) {
        try {
          this.surveyService.modalRef.close();
        } catch(e) {}
        this.surveyService.modalRef = null;
      }
    })
    
    email.valueChanges.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(email=>{
      if(window['utils'].validateEmail(email)){
        this.formGroup.controls['email'].setErrors(null)
      }
    })
  }


  onRatingSelect(evt: any){
    let submitBtn = document.querySelector('#survey-submit')
    submitBtn.removeAttribute('disabled')
    this.isRatingSelected = true
    let target = evt.currentTarget
    let targetValue = evt.currentTarget.value;
    let list = Array.from(document.querySelectorAll('.rating-icon'));
    list.map(el => {
      el.classList.remove('active');
    });
    target.classList.add('active');

    if(targetValue <= 4){
      this.surveySubtitle = "We're so sorry! How can we make this right?"
      this.textAreaLadel = "Optionally, please tell us what didn't work..."
    }
    if(targetValue >= 5 && targetValue <= 7){
      this.surveySubtitle = 'Oh no! How can we improve your experience?'
      this.textAreaLadel = 'Optionally, please tell us what we can do better...'
    }
    if(targetValue >= 8){
      this.surveySubtitle = 'Thank you! We loved working with you <3'
      this.textAreaLadel = 'Optionally, please tell us what you loved...'
    }
    this.surveyRating = evt.currentTarget.value
  }

  onSubmit(){
    if(this.surveyRating == null){
      this.isRatingSelected = false
      return
    }
    this.activeScreen = 'second'
    this.title = 'Can we contact you for a 10 min call?'
    this.responseType = 1
  }

  onPostponed() {
    const payload = {
      responseType: 2,
      postponedFor: this.postponedFor
    }
    this.store.dispatch({
      type:loadRecord.type,
      payload
    })
  }


  onFeedback(status){
    if(status){
      const email = this.formGroup.get('email');
      const isEmailValid = window['utils'].validateEmail(email.value);
      if(!isEmailValid){
        email.setErrors({'incorrect': true});
        email.markAsTouched();
        return;
      }
    }else{
      this.formGroup.controls['email'].setErrors(null)
    }
    this.title = ''
    this.activeScreen = 'third'
    this.isShowMainTitle = false
    this.onClose('auto')
    if(status){
      this.agreeToContact = true
    }else{
      this.agreeToContact = false
    }
    this.orgUser$.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((user)=>{this.user = user})
    if(this.user){
      this.store.dispatch({
        type:loadRecord.type,
        payload:{
          responseType:this.responseType,
          score:this.surveyRating,
          agreeToContact:this.agreeToContact,
          contactEmail:this.formGroup.get('email').value,
          feedback:this.surveyFeedback
        }
      })

    }
  }

  onClose(placeOfCall){
    if(placeOfCall=='modal'){
      if(this.surveyService.modalRef instanceof MdbModalRef) {
        try {
          this.surveyService.modalRef.close();
        } catch(e) {}
        this.surveyService.modalRef = null;
      }
    }else{
      setTimeout(()=>{
        if(this.surveyService.modalRef instanceof MdbModalRef) {
          try {
            this.surveyService.modalRef.close();
          } catch(e) {}
          this.surveyService.modalRef = null;
        }
      },3000)
    }

  }

  ngOnDestroy(): void {
    this.takeUntilSubject.next(null);
    this.takeUntilSubject.complete();

    if(this.surveyService.modalRef instanceof MdbModalRef) {
      try {
        this.surveyService.modalRef.close();
      } catch(e) {}
      this.surveyService.modalRef = null;
    }
    this.store.dispatch({
      type: resetSurvey.type
    });
  }

}
